import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const PalletBaseUrl = '/business/pallet'
export async function queryPallets(params) {
  const result = await request({
    url: PalletBaseUrl,
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query goods failed!') ?? null
}

export async function detailPallet(palletNo) {
  let result = await request({
    url: PalletBaseUrl + '/' + palletNo,
    method: 'GET'
  })
  result = ResultHandler(result, 'Query goods failed!')
  return result ?? null
}

export async function modifyPallet(palletId, pallet) {
  const result = await request({
    url: PalletBaseUrl + '/' + palletId,
    method: 'PUT',
    data: pallet
  })
  return ResultHandler(result, 'Modify pallet failed!')
}

export async function searchStock(params) {
  const result = await request({
    url: PalletBaseUrl + '/stock',
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Search stock failed!')?.page ?? null
}

export async function labelPallet(palletNo) {
  const result = await request({
    url: PalletBaseUrl + `/${palletNo}/label`,
    method: 'GET',
    responseType: 'blob'
  })
  return result
}

export async function getPalletPicture(palletNo, fileName) {
  const result = await request({
    url: PalletBaseUrl + `/${palletNo}/picture/${fileName}`,
    method: 'GET',
    responseType: 'blob'
  })
  return result
}

export async function listPalletPictures(palletNo) {
  const result = await request({
    url: PalletBaseUrl + `/${palletNo}/pictures`,
    method: 'GET'
  })
  return result.data.files
}

export async function deletePalletPicture(palletNo, fileName) {
  const result = await request({
    url: PalletBaseUrl + `/${palletNo}/picture/${fileName}`,
    method: 'DELETE'
  })
  return result
}

export async function labelPallets(palletNos) {
  const result = await request({
    url: PalletBaseUrl + '/label',
    method: 'GET',
    params: {
      nos: palletNos
    },
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType: 'blob'
  })
  return result
}

export async function palletStats(palletId) {
  const result = await request({
    url: PalletBaseUrl + '/' + palletId + '/stats',
    method: 'GET'
  })
  return ResultHandler(result, 'Stats pallet failed!')?.stats ?? null
}

export async function deletePallet(palletId, confirm, username) {
  const result = await request({
    url: PalletBaseUrl + '/' + palletId,
    data: {
      id: palletId,
      confirmDelete: confirm,
      username
    },
    method: 'DELETE'
  })
  return ResultHandler(result, 'Stats pallet failed!') ?? null
}

export async function listPalletProducts(palletNo) {
  let result = await request({
    url: PalletBaseUrl + '/' + palletNo + '/products',
    method: 'GET'
  })
  result = ResultHandler(result, 'Query products failed!')?.products ?? []
  return result ?? null
}
